export default __webpack_public_path__ + "static/media/IMG_0046_3_11zon.1b121247.jpg";